module.exports = __webpack_public_path__ + "/images/cover-fr-acompanamiento.491cc15.jpg";